/**
 * Разбор отказа облака при PUSH чеков (ARCH-TASK-65.9.1).
 *
 * Сервер отвечает 422 `{ error, receipt_id, detail }`, когда конкретный чек
 * невалиден. Такой чек надо исключить из очереди, а не ретраить вечно:
 * иначе одна битая запись блокирует отправку всех продаж кассы.
 *
 * Ответ без `receipt_id` (или не 422) считается временной ошибкой — ретраим.
 */
export interface PushRejection {
  /** id чека, который облако отклонило (UUID). */
  receiptId?: string
  /** Человекочитаемая причина для лога и UI. */
  reason?: string
}

export function parsePushRejection(status: number, body: unknown): PushRejection | null {
  if (status !== 422) return null
  const payload = (body ?? {}) as {
    receipt_id?: unknown
    error?: unknown
    detail?: unknown
  }
  const receiptId =
    typeof payload.receipt_id === 'string' && payload.receipt_id.trim()
      ? payload.receipt_id.trim()
      : undefined
  // Для UI важнее деталь («invalid original_receipt_id: …»), чем код ошибки.
  const detail = typeof payload.detail === 'string' ? payload.detail.trim() : ''
  const error = typeof payload.error === 'string' ? payload.error.trim() : ''
  return {
    receiptId,
    reason: detail || error || undefined
  }
}
